export enum UserActionTypes {
    API_RESPONSE_SUCCESS = '@@user/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@user/API_RESPONSE_ERROR',
    USER_LIST = '@@user/USER_LIST',
    ADD_USER = '@@user/ADD_USER',
    SHOW_USER = '@@user/SHOW_USER',
    UPDATE_USER = '@@user/UPDATE_USER',
    DELETE_USER = '@@user/DELETE_USER',
}
